var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2288 18.752H14.9991C12.6656 18.752 11.4979 18.752 10.6066 19.2061C9.8226 19.6056 9.18564 20.2425 8.78617 21.0265C8.33203 21.9178 8.33203 23.0855 8.33203 25.419V37.0857C8.33203 39.4192 8.33203 40.5854 8.78617 41.4767C9.18564 42.2607 9.8226 42.8988 10.6066 43.2983C11.497 43.7519 12.6633 43.7519 14.9923 43.7519H35.0051C37.3341 43.7519 38.4987 43.7519 39.3891 43.2983C40.1731 42.8988 40.8122 42.2607 41.2117 41.4767C41.6654 40.5863 41.6654 39.4217 41.6654 37.0927V25.4122C41.6654 23.0832 41.6654 21.917 41.2117 21.0265C40.8122 20.2425 40.1731 19.6056 39.3891 19.2061C38.4978 18.752 37.3327 18.752 34.9991 18.752H30.7673M19.2288 18.752H30.7673M19.2288 18.752C18.9633 18.752 18.7487 18.5367 18.7487 18.2712V12.502C18.7487 9.05017 21.5469 6.25195 24.9987 6.25195C28.4505 6.25195 31.2487 9.05017 31.2487 12.502V18.2712C31.2487 18.5367 31.0328 18.752 30.7673 18.752",
    stroke: "#FEB111",
    strokeWidth: 3.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.eb6ef1bbdbc0f6d0ee473e27c8dba0bb.svg";
export { ForwardRef as ReactComponent };